// Generated by CoffeeScript 1.12.7
(function () {
  var UserSignupEntryPoints;

  UserSignupEntryPoints = require("@CommonFrontendBackend/User/types").UserSignupEntryPoints;

  module.exports = function (
    $rootScope,
    $state,
    $location,
    $urlRouter,
    user,
    userList,
    isMobile,
    projectLiveLimit,
    telemetry,
    environment,
    $timeout,
    projectOpener,
  ) {
    /*
     * Add in state transition blocking if necessary
     */
    var ref, ref1, ref2, ref3;
    $rootScope.$on("$stateChangeStart", function (e, toState, toParams, fromState, fromParams) {
      /*
        If we're in mobile mode, we only allow access to the dashboard state
      
        If this is a Starter account that is over the project limit, we only allow access to the
        dashboard and settings pages
      
        NOTE: When developing the client app it can be frustrating when the app switches into
        mobile-only mode (i.e with Chrome Dev tools open), so we keep this behaviour
        for production only.
       */
      var ref;
      if (isMobile() && environment === "production") {
        if (toState.name !== "dashboard") {
          e.preventDefault();
          return $state.go("dashboard", {
            nav: "pages",
          });
        }
      } else if (projectLiveLimit.getOverLimitAmount() > 0) {
        if ((ref = toState.name) !== "dashboard" && ref !== "settings") {
          e.preventDefault();
          return $state.go("dashboard", {
            nav: "pages",
          });
        }
      }
    });

    /*
     * Set the initial app location for the user
    @NOTE(mike, 2018-08-20) A user _shouldn't_ have a sessionCount of 0 if they reached this point
    but let's use <= 1 just in case.
     */
    if (user.useHistory.sessionCount <= 1) {
      if (
        ((ref = user.useHistory) != null
          ? (ref1 = ref.signup) != null
            ? (ref2 = ref1.entryPoint) != null
              ? ref2.type
              : void 0
            : void 0
          : void 0) === UserSignupEntryPoints.AdminPanelDocConversion
      ) {
        $timeout(function () {
          return $location.path("/templates");
        });
        $state.go("templates");
      } else {
        $timeout(function () {
          return $location.path("/pages");
        });
        $state.go("dashboard", {
          nav: "pages",
        });
      }
    } else if ((ref3 = $location.path()) === "/" || ref3 === "") {
      $timeout(function () {
        return $location.path("/pages");
      });
      $state.go("dashboard", {
        nav: "pages",
      });
    }
    return $urlRouter.sync();
  };
}.call(this));
